import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LogoMark } from '../Logo';
import '../../styles/admin-theme.css';

/**
 * Lightweight admin chrome for satellite pages (Badges, Marketing, Reporting).
 * Matches AdminDashboard shell — no consumer navbar.
 */
export function AdminSatelliteShell({ title, subtitle, actions, children }) {
  return (
    <div className="admin-shell min-h-screen bg-[#f6f7f5]">
      <header className="sticky top-0 z-30 border-b border-[#e8ece9] bg-[#f6f7f5]/95 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-4 min-w-0">
            <Link
              to="/admin-dashboard"
              className="admin-pill shrink-0 inline-flex items-center gap-1.5 no-underline"
            >
              <ArrowLeft className="w-4 h-4" aria-hidden="true" />
              Admin
            </Link>
            <div className="flex items-center gap-3 min-w-0">
              <LogoMark size={22} className="text-[var(--pf-ink)] shrink-0 hidden sm:block" />
              <div className="min-w-0">
                <p className="text-xs font-bold uppercase tracking-wider text-[#5c6670]">PetsFostering Admin</p>
                <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-[#0c0f14] truncate">{title}</h1>
                {subtitle ? (
                  <p className="text-sm text-[#5c6670] truncate">{subtitle}</p>
                ) : null}
              </div>
            </div>
          </div>
          {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
    </div>
  );
}

export default AdminSatelliteShell;
